import React from "react";
import { Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { getUserReferralHistoryAsync } from "../../redux/userManagementApi";
import { UserManagementActions } from "../../redux/userManagementAction";

const ReferrerHistoryModal = ({ show, onHide, selectedUser }) => {
  const dispatch = useDispatch();
  
  const { referralHistory, isReferralHistoryLoading } = useSelector(
    (state) => state.userManagement,
    shallowEqual
  );
  
  React.useEffect(() => {
    if (show && selectedUser?._id) {
      dispatch(getUserReferralHistoryAsync(selectedUser._id));
    }
  }, [show, selectedUser, dispatch]);

  const handleClose = () => {
    dispatch(UserManagementActions.getUserReferralHistorySuccess([]));
    onHide();
  };

  const getStatusInfo = (status) => {
    switch (status) {
      case "BONUS_CREDITED":
        return { 
          text: "Credited", 
          class: "status-credited",
          icon: "✅",
          color: "#10b981",
          bgColor: "#d1fae5"
        };
      case "FIRST_BET_COMPLETED":
        return { 
          text: "Awaiting Credit", 
          class: "status-awaiting",
          icon: "⏳",
          color: "#f59e0b",
          bgColor: "#fef3c7"
        };
      case "SIGNUP_COMPLETED":
        return { 
          text: "Awaiting First Bet", 
          class: "status-pending",
          icon: "🎯",
          color: "#3b82f6",
          bgColor: "#dbeafe"
        };
      default:
        return { 
          text: "Pending", 
          class: "status-pending",
          icon: "⏸️",
          color: "#6b7280",
          bgColor: "#f3f4f6"
        };
    }
  };

  const formatCoins = (amount) => {
    return new Intl.NumberFormat().format(amount || 0);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      className="def_modal delete_modal"
      style={{ zIndex: 9999 }}
       enforceFocus={false}
    >

   

      <Modal.Header 
        closeButton 
        className="border-0 pb-0 position-relative"
        style={{ 
          background: '#000',
          color: 'white',
          position: 'relative',
          zIndex: 10
        }}
      >
        <div className="position-absolute top-0 start-0 w-100 h-100" 
             style={{ 
               background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
               pointerEvents: 'none',
               zIndex: 1
             }}></div>
        <Modal.Title className="fw-bold fs-3 mb-0 position-relative" style={{ zIndex: 2 }}>
          <div className="d-flex align-items-center">
          
            <div className="py-5">
              <div className="fw-bold text-white">Referrer History: &nbsp;
                {selectedUser?.userName || selectedUser?.displayName || "User"}
              </div>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="p-0" style={{ backgroundColor: '#f8fafc' }}>
        {isReferralHistoryLoading ? (
          <div className="text-center py-5">
            <div className="position-relative d-inline-block">
              <CircularProgress 
                size={60} 
                thickness={4}
                style={{ color: '#667eea' }}
              />
              <div className="position-absolute top-50 start-50 translate-middle">
                <span style={{ fontSize: '1.2rem' }}>📈</span>
              </div>
            </div>
            <p className="mt-4 text-muted fs-5">Loading referral history...</p>
          </div>
        ) : referralHistory && referralHistory.length > 0 ? (
          <div className="p-4">
            
            
            <div className="table-responsive">
              <Table hover className="mb-0 referral-table">
                <thead>
                  <tr>
                    <th className="border-0 py-4 px-4 fw-bold text-muted text-uppercase" 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                      #
                    </th>
                    <th className="border-0 py-4 px-4 fw-bold text-muted text-uppercase" 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                      Email
                    </th>
                    <th className="border-0 py-4 px-4 fw-bold text-muted text-uppercase text-center" 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                      Referral Bonus
                    </th>
                    <th className="border-0 py-4 px-4 fw-bold text-muted text-uppercase text-center" 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                      Sign-up User Bonus
                    </th>
                    <th className="border-0 py-4 px-4 fw-bold text-muted text-uppercase" 
                        style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {referralHistory.map((history, index) => {
                    const statusInfo = getStatusInfo(history.status_progress);
                    return (
                      <tr key={index} className="referral-row">
                        <td className="border-0 py-4 px-4">
                          <div className="d-flex align-items-center text-dark  justify-content-center" 
                               >
                            {index + 1}
                          </div>
                        </td>
                        
                        <td className="border-0 py-4 px-4">
                          <div className="d-flex align-items-center">
                            
                            <div>
                              <div className="fw-bold text-dark mb-1" style={{ fontSize: '15px' }}>
                                {history.email || "-"}
                              </div>
                              {history.user_name && (
                                <small className="text-muted d-flex align-items-center">
                                  <span className="me-1">👤</span>
                                  {history.user_name}
                                </small>
                              )}
                            </div>
                          </div>
                        </td>
                        
                        <td className="border-0 py-4 px-4 text-center">
                          <div className="coin-badge coin-badge-success">
                            <span className="coin-icon">💰</span>
                            <span className="coin-amount">{formatCoins(history.referral_bonus_coins)}</span>
                            <span className="coin-label">coins</span>
                          </div>
                        </td>
                        
                        <td className="border-0 py-4 px-4 text-center">
                          <div className="coin-badge coin-badge-primary">
                            <span className="coin-icon">🎁</span>
                            <span className="coin-amount">{formatCoins(history.referral_sign_up_user_bonus)}</span>
                            <span className="coin-label">coins</span>
                          </div>
                        </td>
                        
                        <td className="border-0 py-4 px-4">
                          <div className="status-container">
                            <div className="d-flex align-items-center mb-2">
                           
                              <span 
                                className="status-badge"
                                style={{ 
                                  backgroundColor: statusInfo.bgColor,
                                  color: statusInfo.color,
                                  padding: '6px 16px',
                                  borderRadius: '20px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  border: `2px solid ${statusInfo.color}20`
                                }}
                              >
                                {statusInfo.text}
                              </span>
                            </div>
                            
                            
                            
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <div className="text-center py-5 empty-state">
            <div className="empty-icon mb-4">
              <div style={{ 
                fontSize: '4rem', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                📭
              </div>
            </div>
            <h4 className="text-muted mb-3 fw-semibold">No Referral History</h4>
            <p className="text-muted mb-0 fs-5">
              This user hasn't referred anyone yet. Share their referral code to start earning!
            </p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ReferrerHistoryModal;
